import { render, staticRenderFns } from "./callList.vue?vue&type=template&id=a1d4cb38&scoped=true"
import script from "./callList.vue?vue&type=script&lang=js"
export * from "./callList.vue?vue&type=script&lang=js"
import style0 from "./callList.vue?vue&type=style&index=0&id=a1d4cb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d4cb38",
  null
  
)

export default component.exports